import styled from 'styled-components';
import Button from '@mui/material/Button';

const FormContainer = styled.div<{ hideSecondResizeIcon?: boolean }>`
	display: flex;
	flex-direction: column;
	width: 100%;

	& .MuiDataGrid-columnSeparator {
		visibility: ${(props) => props?.hideSecondResizeIcon && 'hidden'};
	}

	& .MuiDataGrid-columnSeparator--resizable {
		visibility: visible !important ;
	}

	& .MuiDataGrid-treeDataGroupingCellToggle {
		visibility: hidden;
	}
`;

const FormHeader = styled.div<{ margin?: string; readOnly?: boolean }>`
	display: flex;
	margin: ${(props) => props?.margin || '0px 0px 30px 0px'};
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 20px;
	margin-bottom: 30px;
	& .MuiOutlinedInput-notchedOutline,
	.MuiFormLabel-root {
		border-color: ${(props) => !props?.readOnly && ' #ff9800 !important'};
		color: ${(props) => !props?.readOnly && ' #ff9800 !important'};
	}
`;

const LastEdited = styled.h6<{ marginBottom?: string }>`
	margin: 0px;
	margin-bottom: ${(props) => props?.marginBottom};
`;

const LastEditedActions = styled.div`
	display: flex;
	gap: 5px;
	margin-right: 20px;
	& button {
		width: fit-content;
		min-width: fit-content;
	}
`;

const AlreadyEditingText = styled.h6`
	color: #ed6c02;
	display: inline-flex;
	margin-bottom: 0px;
`;

// MODAL
const Title = styled.h4`
	width: 100%;
	text-align: center;
	margin-bottom: 30px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 18px;
`;

const ReadyToPublishButton = styled(Button)<{ isReadyToPublish?: boolean; status?: string }>`
	display: ${({ isReadyToPublish, status }) =>
		isReadyToPublish || status === 'Published' ? 'none' : 'inherit'};
`;

const Description = styled.p<{ center?: boolean }>`
	text-align: ${(props) => props?.center && 'center'};
`;

const ButtonContainer = styled.div<{ marginTop?: boolean }>`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 25px;
	margin-top: ${(props) => props?.marginTop && '40px'};
	padding-top: 75px;
`;

const CardRowInfoOverflowed = styled.h6<{ centerText?: boolean }>`
	color: black;
	text-overflow: ellipsis;
	max-width: 64ch;
	white-space: nowrap;
	overflow: hidden;
	text-align: ${(props) => props?.centerText && 'center!important;'};
`;

const CellContainer = styled.div<{ margin?: string; marginLeft?: string; status?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	gap: 6px;
	width: 100%;
	max-width: fit-content;
	margin: ${(props) => props?.margin};
	margin-left: ${(props) => props?.marginLeft};
	color: ${(props) => props?.status && 'rgba(0, 0, 0, 0.38)'};
	pointer-events: ${(props) => props?.status && 'none'};
	overflow: hidden;
	text-overflow: ellipsis;
`;

const CardRowInfoText = styled.div<{ disabled?: boolean; centerText?: boolean }>`
	width: '80%';
	color: ${(props) => (props?.disabled ? 'rgba(0, 0, 0, 0.38)' : 'black')};
	white-space: normal;
	text-align: ${(props) => props?.centerText && 'center!important;'};
	word-break: break-word;
`;

export default {
	FormContainer,
	FormHeader,
	LastEdited,
	LastEditedActions,
	AlreadyEditingText,
	Title,
	Description,
	ButtonContainer,
	ReadyToPublishButton,
	CardRowInfoOverflowed,
	CellContainer,
	CardRowInfoText
};
